import './form/form';

import React from 'react';
import ReactDOM from 'react-dom';

import { Geolocation } from './location/geolocation';
import { Location } from './location/location';
import { Validation, FormValidation } from './validation/validation';
import { Tracking } from './tracking/tracking';
import { Profile } from './profile/profile';
import { ProfileServices } from './profile/services'
import { Settings } from './profile/settings';

import { Achievements } from './achievement/achievements'
import { AchievementsOverlay } from './achievement/achievements-overlay'

import { Messages } from './messages/messages';
import { Notification } from './nav/notification';
import { Map } from './map/map';
import { Copromote } from './copromote/copromote';
import { Evedo } from './evedo';
import { Event } from './event/event';
import { Host } from './host/host';
import { EventEditor } from './event/event-editor';
import { TicketsEditor } from './ticket/tickets-editor';
import { Hosts } from './nav/hosts';
import { Events } from './nav/events';
import { EventsList } from './event/list';
import { EventStats } from './event/stats';
import { Friends } from './social/friends';
import { ManageTickets } from './ticket/manage';
import { Yard } from './event/yard';
import { TokenList } from './ui/token_list';
import { Calendar } from './calendar/calendar';
import { FeaturedWidget, FeaturedCampaignsReportModal, FeatureModal, StepsBarControl } from './modals/featured';
import { initCustomForms, initCustomCheckboxes, initCustomRadios, customFormsClickHandler, initTabs } from './common';
import { DataLoader } from './loaders';
import { City } from './city';

import { CityAutocomplete } from './autocomplete/city'
import { TagAutocomplete } from './autocomplete/tag'

import { AdvancedSearch } from './search/advanced-search'

import { Exchange } from './exchange/exchange'
import { ExchangeTransaction } from './exchange/exchange-transaction'

import { Seats } from './order/seats';

import { Navigation } from './header/navigation';
import { Footer } from './footer/footer';
import { Discover } from './discover/discover';
import { Homepage } from './homepage/homepage';
import { Search } from './search/search';
import './event/datepicker'; //Added copy of /node_modules/jquery-ui/ui/widgets/datepicker.js for styling purposed ( arrows were missing )
import './library';

export default { React, ReactDOM, Evedo, Event, Host, Profile, ProfileServices, Geolocation, Location, Tracking, Notification, Map, EventEditor, TicketsEditor, Copromote, Validation, Hosts, Events, EventsList, Yard, EventStats, ManageTickets, TokenList, Calendar, initCustomForms, initCustomCheckboxes, initCustomRadios, initTabs, customFormsClickHandler, Settings, City, Friends, FeaturedWidget, FeaturedCampaignsReportModal, FeatureModal, StepsBarControl, DataLoader, CityAutocomplete, TagAutocomplete, Achievements, AchievementsOverlay, Messages, AdvancedSearch, Exchange, ExchangeTransaction, Navigation, Discover, Homepage, Footer, Seats, Search, FormValidation }
